// extracted by mini-css-extract-plugin
export var contentItem = "relatedContent-module--content-item--lnwwD";
export var contentPreviews = "relatedContent-module--content-previews--8HdOW";
export var relatedContent = "relatedContent-module--related-content--jORqn";